import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from '../../../components/BobTableContextMenu.module.css';

const HealthMonitorTableContextMenu = ({
    dataItem,
    setCreateServiceRequestModalOpen,
    setHealthInfoModalOpen,
    setSelectedHealthCheck,
    onSubscribeToAlerts,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    const handleViewDetails = () => {
        setSelectedHealthCheck(dataItem);
        setHealthInfoModalOpen(true);
    };

    const handleServiceRequest = () => {
        setSelectedHealthCheck(dataItem);
        setCreateServiceRequestModalOpen(true);
    };

    const handleSubscription = () => {
        onSubscribeToAlerts(dataItem);
    };

    const renderMenu = () => {

        return (
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => handleViewDetails()}
                >
                    <span class="material-icons-outlined md-18">
                        info
                    </span>
                    View More Info
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => handleServiceRequest()}
                >
                    <span class="material-icons-outlined md-18">
                        build
                    </span>
                    New Service Request
                </MenuItem>
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={() => handleSubscription()}
                >
                    <span class="material-icons-outlined md-18">
                        notifications
                    </span>
                    Subscribe to Alerts
                </MenuItem>
            </Menu>
        );
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            { renderMenu()}
        </React.Fragment>
    );
};

export default HealthMonitorTableContextMenu;
